import { formatDateFromServer } from "~/libs/getFormatDate";
import { useTranslation } from "react-i18next";

export const setFieldsConfig = ({ course }) => {
  const { t } = useTranslation();
  return [
    {
      isDatePicker: true,
      name: "createdAt",
      defaultValue: course.createdAt
        ? new Date(formatDateFromServer(course.createdAt))
        : "",
      label: t("patp.createdAt"),
    },
    {
      isDatePicker: true,
      name: "updatedAt",
      defaultValue: course.updatedAt
        ? new Date(formatDateFromServer(course.updatedAt))
        : "",
      label: t("patp.updatedAt"),
    },
    {
      isDatePicker: true,
      name: "dateActiveStatus",
      defaultValue: course.dateActiveStatus
        ? new Date(formatDateFromServer(course.dateActiveStatus))
        : "",
      label: t("patp.activation_date"),
    },
    {
      isDatePicker: true,
      name: "dateInactiveStatus",
      defaultValue: course.dateInactiveStatus
        ? new Date(formatDateFromServer(course.dateInactiveStatus))
        : "",
      label: t("patp.deactivation_date"),
    },
  ];
};
